import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LuciTableMultiColumnSortingComponent } from './luci-table-multi-column-sorting.component';
import {LuciDialogModule} from '../luci-dialog/luci-dialog.module';
import {LuciDropdownModule} from '../luci-dropdown/luci-dropdown.module'
import {LuciCheckboxModule} from '../luci-checkbox/luci-checkbox.module';
import {LuciButtonModule} from '../luci-button/luci-button.module';



@NgModule({
  declarations: [LuciTableMultiColumnSortingComponent],
  imports: [
    CommonModule,
    LuciDialogModule,
    LuciDropdownModule,
    LuciCheckboxModule,
    LuciButtonModule
  ],
  exports: [LuciTableMultiColumnSortingComponent]
})
export class LuciTableMultiColumnSortingModule { }
